export const masonryBreakpointCols = {
  default: 3,
  1190: 2,
  768: 1,
};

export const NotFoundStatusCode = 404;

// текст ошибок валидации полей форм
export const requiredText = 'обязательное поле';
export const invalidFIOText =
  'должно содержать только кириллицу, тире и пробел';
export const minPasswordLengthText = 'минимальная длина пароля 8 символов';
export const passwordMismatchText = 'пароли не совпадают';
export const invalidEmailFormatText = 'неверный формат email';
export const invalidPhoneNumberFormatText = 'неверный формат телефона';
export const invalidUrlText = 'неверный формат ссылки';
export const invalidSocialUrlText =
  'должно быть ссылкой или начинаться с символа @';
export const notOnlySpacesText = 'не должно содержать только пробелы';
export const fourRequiredDigitsText = 'должно содержать 4 цифры';
export const sixRequiredDigitsText = 'должно содержать 6 цифр';
export const departmentCodeMaskText = 'должно быть в формате ххх-ххх';
export const userEmailExistsText =
  'пользователь с таким номером телефона уже существует';
export const userEmailNotExistsText =
  'пользователь с таким номером телефона не существует';
export const supportedPhoneFormatText =
  'поддерживаются только номера формата: +7 (9..) ...';
export const errorSmsInvalidPhoneNumber =
  'не удалось отправить код на этот номер телефона';
export const errorAuthRequestPer2MinText =
  'интервал запроса нового кода - 2 минуты';
export const checkFilledEmailText = 'проверьте правильность введенного email';
export const checkFilledPasswordText =
  'проверьте правильность введенного пароля';
export const duplicatedEmailText =
  'пользователь с таким email уже зарегистрирован';
export const duplicatedPhoneText =
  'пользователь с таким номером телефона уже зарегистрирован';
export const duplicatedQuizTeam =
  'команда с таким названием уже зарегистрирована другим участником';
export const duplicatedPhoneServerError = 'duplicated phone';
export const duplicatedEmailServerError = 'duplicated email';
export const supportedPhoneFormatServerError =
  'only +7 (9..)-... phones allowed';
export const under18YearsOldText = 'менее 18 лет';

export const FIOPattern = /^[\u0400-\u04FF\-\s]+$/;
export const digitsPattern = /^\d+$/;
export const EmailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const UrlPattern =
  /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@!\$&'\(\)\*\+,;=.]+$/i;

export const phoneNumberMask = '+7 (999) 999-99-99';
export const emptyPhoneNumberMask = '+7 (___) ___-__-__';

export const privacyPolicyDocUrl =
  'https://roz-events.storage.yandexcloud.net/media/documents/privacy_policy.pdf';
export const userAgreementDocUrl =
  'https://roz-events.storage.yandexcloud.net/media/documents/user_agreement.pdf';
export const rozInviteRulesDocUrl =
  'https://roz-events.storage.yandexcloud.net/media/documents/roz_invite_rules.pdf';

export const SDK_VERSION = '1.1.12';
